import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Brow variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */
export const browVariants = cva('font-bold text-b5 uppercase', {
  variants: {
    color: {
      default: 'text-secondary-700',
      white: 'text-white',
    },
    align: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
    },
  },
  defaultVariants: {
    color: 'default',
  },
});

export type BrowVariantProps = VariantProps<typeof browVariants>;
